import {
  RAFFLE_PRIZE_DATA_REQUEST,
  RAFFLE_PRIZE_DATA_SUCCESS,
  RAFFLE_PRIZE_DATA_FAILURE
} from 'Store/constants';

const initialState = {
  data: [],
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case RAFFLE_PRIZE_DATA_REQUEST:
      return { ...state, isLoading: true, error: null };
    case RAFFLE_PRIZE_DATA_SUCCESS: {
      const { prizeInfoResponse = [] } = action.payload;
      return {
        data: prizeInfoResponse,
        isLoading: false,
        error: null
      };
    }
    case RAFFLE_PRIZE_DATA_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
